import { gql } from "apollo-angular";
import { ILLINKSnippet, INLNK } from "./template-nav-links";

export const  LINK_FIELDS = gql`
  fragment LINK_FIELDS on Link {
    internalLink {
        ${ILLINKSnippet}
    }
    linkTitle
    docLink {
      ...DOCLNK
    }
    cssClass
    linkTarget
    externalLink
    chatLinkCheckBox
    jumpTarget
  }
${INLNK}
fragment DOCLNK on Document {
    fileName,
    path
  }`;